import { Loader2 } from 'lucide-react'
import { useFetchSignatureByIdUserView, useFetchSignatureByIdVerifed } from '@/features/signatures/services'
import { SignatureDetails } from './SignatureDetails'

export type Witness = {
  nome: string
  cpf: string
  maquina: string
  local: string
  assinatura: string
}

export type Cliente = {
  ass_testemunha_cliente_1: string
  ass_testemunha_cliente_2: string
  assinatura: string
  check_testemunha_1: boolean
  check_testemunha_2: boolean
  cnpj: string
  cpf: string
  cpf_testemunha_cliente_1: string
  cpf_testemunha_cliente_2: string
  createData: string
  deletedData: string | null
  fotoDoc: string
  fotoPessoa: string
  id: number
  id_user: number | null
  isAtivo: boolean
  isModifica: boolean
  isVerifed: boolean
  local: string
  local_1: string
  local_2: string
  maquina: string
  maquina_1: string
  maquina_2: string
  nome: string
  nome_testemunha_cliente_1: string
  nome_testemunha_cliente_2: string
  witness1?: Witness | null
  witness2?: Witness | null
}
export type VerificationSignatureProps = {
  id: string
  role: 'owner' | 'user'
}
export default function ViewSignaturePage({ id, role }: VerificationSignatureProps) {
  const isOwner = role === 'owner'

  const {
    data: clientCNPJ,
    isLoading: loadingCNPJ,
    error: errorCNPJ
  } = useFetchSignatureByIdVerifed(id, { enabled: isOwner })

  const {
    data: clientUser,
    isLoading: loadingUser,
    error: errorUser
  } = useFetchSignatureByIdUserView(id, { enabled: !isOwner })

  const cliente: Cliente | undefined = isOwner ? (clientCNPJ as Cliente) : (clientUser as Cliente)
  const isLoading = isOwner ? loadingCNPJ : loadingUser
  const error = isOwner ? errorCNPJ : errorUser

  const witnesses: Witness[] = [cliente?.witness1, cliente?.witness2].filter((witness): witness is Witness => Boolean(witness))

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <p className="text-lg font-semibold text-red-600 text-center">Erro ao carregar assinatura.</p>
      </div>
    )
  }

  if (!cliente) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <p className="text-lg font-semibold text-red-600 text-center">Assinatura não encontrada.</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen px-4 py-6 bg-background">
      <div className="w-full max-w-5xl mx-auto">
        {/* 2) SOMENTE VISUALIZAÇÃO */}
        <SignatureDetails
          ownerName={cliente.nome}
          ownerCpf={cliente.cpf}
          isVerifed={cliente.isVerifed}
          device={cliente.maquina}
          createdAt={cliente.createData}
          location={cliente.local}
          selfieSrc={cliente.fotoPessoa}
          signatureSrc={cliente.assinatura}
          documentSrc={cliente.fotoDoc || '/placeholder.png'}
          witnesses={witnesses}
        />
      </div>
    </div>
  )
}
